import { Talent } from "../../Classes";

export default [
  null,
  null,
  new Talent(
    "Ranged Weapon Specialization",
    "inv_weapon_rifle_06",
    ["Increases the damage you deal with ranged weapons by ", "%."],
    5,
    [[1, 2, 3, 4, 5]]
  ),
  null,
];
